import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('rules')

export const EMPTY_STRING = ''

export const FETCH_RULES = makeConstant('FETCH_RULES')
export const FETCH_RULES_PENDING = makeConstant('FETCH_RULES_PENDING')
export const FETCH_RULES_CANCELLED = makeConstant('FETCH_RULES_CANCELLED')
export const FETCH_RULES_FAILED = makeConstant('FETCH_RULES_FAILED')
export const FETCH_RULES_SUCCESS = makeConstant('FETCH_RULES_SUCCESS')

export const FETCH_RULES_BY_IDS = makeConstant('FETCH_RULES_BY_IDS')
export const FETCH_RULES_BY_IDS_PENDING = makeConstant('FETCH_RULES_BY_IDS_PENDING')
export const FETCH_RULES_BY_IDS_CANCELLED = makeConstant('FETCH_RULES_BY_IDS_CANCELLED')
export const FETCH_RULES_BY_IDS_FAILED = makeConstant('FETCH_RULES_BY_IDS_FAILED')
export const FETCH_RULES_BY_IDS_SUCCESS = makeConstant('FETCH_RULES_BY_IDS_SUCCESS')

export const FETCH_ROUND_ROBIN_BY_KEY = makeConstant('FETCH_ROUND_ROBIN_BY_KEY')
export const FETCH_ROUND_ROBIN_BY_KEY_PENDING = makeConstant('FETCH_ROUND_ROBIN_BY_KEY_PENDING')
export const FETCH_ROUND_ROBIN_BY_KEY_FAILED = makeConstant('FETCH_ROUND_ROBIN_BY_KEY_FAILED')
export const FETCH_ROUND_ROBIN_BY_KEY_SUCCESS = makeConstant('FETCH_ROUND_ROBIN_BY_KEY_SUCCESS')
export const FETCH_ROUND_ROBIN_BY_KEY_CANCELLED = makeConstant('FETCH_ROUND_ROBIN_BY_KEY_CANCELLED')

export const EDIT_RULE = 'EDIT_RULE'
export const RESET_ACTIVE_RULE = 'RESET_ACTIVE_RULE'
export const RESET_ACTIVE_RULE_ACTION = 'RESET_ACTIVE_RULE_ACTION'
export const PARTICIPANT_ADD_TYPES = { ONE: 'ADD_ONE', ALL: 'ADD_ALL' }
export const ACTION_TYPES = {
  PARTICIPANT: 'PARTICIPANT',
  SALESFORCE_PARTICIPANT: 'SALESFORCE_PARTICIPANT',
  ABM_PARTICIPANT: 'ABM_PARTICIPANT',
  LEANDATA_PARTICIPANT: 'LEANDATA_PARTICIPANT',
}

//GEO
export const GEO_FILTER_OPERATORS = { IS_ANY: 'isAnyOf', IS_NOT: 'notIsAnyOf' }
export const GEO_FILTER_TYPES = { STATE: 'geoState', COUNTRY: 'geoCountryCode' }
export const REGION_LABELS = {
  northeast: 'Northeast',
  south: 'South',
  west: 'West',
  midwest: 'Midwest',
}

export const CONTINENT_LABELS = {
  AFRICA: 'Africa',
  ASIA: 'Asia',
  EUROPE: 'Europe',
  MIDDLE_EAST: 'Middle East',
  NORTH_AMERICA: 'North America',
  CENTRAL_AMERICA_CARRIBEAN: 'Central America & Carribean',
  SOUTH_AMERICA: 'South America',
  OCEANIA: 'Oceania',
}

//FIRMO
export const EMPLOYEES_FILTER_OPERATORS = { GT: 'greaterThan', LT: 'lessThan', BTW: 'isBetween' }
export const MONEY_RAISED_FILTER_OPERATORS = { GT: 'greaterThan', LT: 'lessThan', BTW: 'isBetween' }
export const REVENUE_FILTER_OPERATORS = { GT: 'greaterThan', LT: 'lessThan', BTW: 'isBetween' }
export const CATEGORY_FILTER_OPERATORS = { IS_ANY: 'isAnyOf', IS_NOT: 'notIsAnyOf' }
export const DEMANDBASE_FILTER_OPERATORS = { IS_ANY: 'isAnyOf', IS_NOT: 'notIsAnyOf', BTW: 'isBetween' }

export const FIRMOGRAPHIC_FILTER_TYPES = {
  EMPLOYEES: 'clearbit_employees',
  MONEY_RAISED: 'clearbit_raised',
  COMPANY_CATEGORIES: 'clearbit_tags_company',
  MARKET_CATEGORIES: 'clearbit_tags_market',
  TECH_TAGS: 'clearbit_tech',
  HEADQUARTERS_STATE: 'clearbit_state',
  HEADQUARTERS_COUNTRY: 'clearbit_country',
  HEADQUARTERS_POSTAL_CODE: 'clearbit_postal_code',
  REVENUE: 'clearbit_revenue',
  DEMANDBASE_AUDIENCE: 'demandbase_audience',
  DEMANDBASE_EMPLOYEE_COUNT: 'demandbase_employee_count',
  DEMANDBASE_INDUSTRY: 'demandbase_industry',
  DEMANDBASE_SUB_INDUSTRY: 'demandbase_sub_industry',
  DEMANDBASE_EMPLOYEE_RANGE: 'demandbase_employee_range',
  DEMANDBASE_MARKETING_ALIAS: 'demandbase_marketing_alias',
  DEMANDBASE_ANNUAL_SALES: 'demandbase_annual_sales',
  DEMANDBASE_REVENUE_RANGE: 'demandbase_revenue_range',
  DEMANDBASE_HEADQUARTERS_CITY: 'demandbase_city',
  DEMANDBASE_HEADQUARTERS_STATE: 'demandbase_state',
  DEMANDBASE_HEADQUARTERS_COUNTRY: 'demandbase_country_code',
}

export const FIRMOGRAPHIC_FILTER_TYPE_LABELS = {
  EMPLOYEES: 'Number of Employees',
  MONEY_RAISED: 'Money Raised',
  COMPANY_CATEGORIES: 'Company Categories',
  MARKET_CATEGORIES: 'Market Categories',
  TECH_TAGS: 'Technology Used',
  HEADQUARTERS_STATE: 'Headquarter State',
  HEADQUARTERS_COUNTRY: 'Headquarter Country',
  HEADQUARTERS_POSTAL_CODE: 'Headquarter Postal Code',
  REVENUE: 'Annual Revenue',
  DEMANDBASE_AUDIENCE: 'Demandbase - Audience',
  DEMANDBASE_EMPLOYEE_COUNT: 'Demandbase - Number of Employees',
  DEMANDBASE_INDUSTRY: 'Demandbase - Industry',
  DEMANDBASE_SUB_INDUSTRY: 'Demandbase - Sub-Industry',
  DEMANDBASE_EMPLOYEE_RANGE: 'Demandbase - Employee Range',
  DEMANDBASE_MARKETING_ALIAS: 'Demandbase - Marketing Alias',
  DEMANDBASE_ANNUAL_SALES: 'Demandbase - Annual Sales',
  DEMANDBASE_REVENUE_RANGE: 'Demandbase - Revenue Range',
  DEMANDBASE_HEADQUARTERS_CITY: 'Demandbase - City',
  DEMANDBASE_HEADQUARTERS_STATE: 'Demandbase - State',
  DEMANDBASE_HEADQUARTERS_COUNTRY: 'Demandbase - Country',
}

export const REVENUE_GROUPS = [
  {
    label:'$0-$1M',
    value: '$0-$1M'
  },
  {
    label:'$1M-$10M',
    value: '$1M-$10M'
  },
  {
    label:'$10M-$50M',
    value: '$10M-$50M'
  },
  {
    label:'$50M-$100M',
    value: '$50M-$100M'
  },
  {
    label:'$100M-$250M',
    value: '$100M-$250M'
  },
  {
    label:'$250M-$500M',
    value: '$250M-$500M'
  },
  {
    label:'$500M-$1B',
    value: '$500M-$1B'
  },
  {
    label:'$1B-$10B',
    value: '$1B-$10B'
  },
  {
    label:'$10B+',
    value: '$10B+'
  }
]

export const EMPLOYEE_NUMBER_GROUPS = [
  { min: 0, max: 10 },
  { min: 11, max: 25 },
  { min: 26, max: 50 },
  { min: 51, max: 200 },
  { min: 201, max: 500 },
  { min: 501, max: 2000 },
]

export const MONEY_RAISED_GROUPS = [
  { min: 0, max: 2 },
  { min: 2, max: 10 },
  { min: 10, max: 20 },
  { min: 20, max: 35 },
]

//DISPLAY WHEN
export const SITE_VISITS_OPERATORS = { GT: 'greaterThan', LT: 'lessThan', BTW: 'isBetween' }
export const DISPLAY_WHEN_FILTER_TYPES = {
  SITE_VISITS: 'siteVisits',
}

export const DISPLAY_WHEN_FILTER_TYPE_LABELS = {
  SITE_VISITS: 'Number of Site Visits',
}

export const SITE_VISITS_GROUPS = [{ min: 0, max: 1 }, { min: 2, max: 4 }, { min: 5, max: 10 }]

//url
export const URL_FILTER_OPERATORS = { IS_ANY: 'isAnyOf', INCLUDES_ANY: 'includesAnyOf', IS_NOT: 'notIsAnyOf' }
export const URL_FILTER_OPERATOR_LABELS = { IS_ANY: 'is', INCLUDES_ANY: 'includes', IS_NOT: 'is not' }

export const URL_FILTER_TYPES = {
  URL_PATH: 'urlPath',
  URL_HOST: 'urlHost',
  URL_QUERY: 'urlQuery',
}

export const URL_FILTER_TYPE_LABELS = {
  URL_PATH: 'URL Path',
  URL_HOST: 'URL Host',
  URL_QUERY: 'URL Query Param',
}

//SALESFORCE
export const SALESFORCE_FILTER = 'salesforceOwner'

export const SALESFORCE_OPERATORS = { IS: 'is' }

//TARGETED ACCOUNTS
export const TARGETED_ACCOUNTS_FILTER = 'targetedAccounts'

export const TARGETED_ACCOUNTS_OPERATORS = { IS: 'is' }

//MISC
export const OPERATOR_LABELS = {
  isAnyOf: 'is',
  notIsAnyOf: 'is not',
  isBetween: 'is between',
  includesAnyOf: 'is',
}

export const SUB_TYPE_LABELS = {
  clearbit_employees: 'has Number of Employees',
  clearbit_raised: 'is Money Raised',
  clearbit_tags_company: 'is Company Categories',
  clearbit_tags_market: 'is Market Categories',
  clearbit_tech: 'is Technology Used',
  clearbit_state: 'is Headquarter State',
  clearbit_country: 'is Headquarter Country',
  clearbit_postal_code: 'is Headquarter Postal Code',
  clearbit_revenue: 'is Annual Revenue',
  demandbase_company_name: 'is Company',
  demandbase_audience: 'is in Audience',
  demandbase_industry: 'is in Industry',
  demandbase_sub_industry: 'is in Sub Industry',
  demandbase_employee_count: 'Number of Employees',
  demandbase_employee_range: 'has Employee Range',
  demandbase_marketing_alias: 'has Marketing Alias',
  demandbase_annual_sales: 'Annual Sales',
  demandbase_revenue_range: 'has Revenue Range',
  demandbase_state: 'is Headquarter State',
  demandbase_country_code: 'is Headquarter Country',
  demandbase_city: 'is Headquarter City',
  urlHost: 'host is',
  urlPath: 'path is',
  urlQuery: 'query param is',
  salesforceOwner: 'Salesforce Owner',
  leandata: 'LeanData Owner',
}

export const CONDITION_TYPE_LABELS = {
  geoState: 'Geolocation',
  geoCountryCode: 'Geolocation',
  clearbit_employees: 'Firmographics',
  clearbit_raised: 'Firmographics',
  clearbit_tags_company: 'Firmographics',
  clearbit_tags_market: 'Firmographics',
  clearbit_tech: 'Firmographics',
  clearbit_state: 'Firmographics',
  clearbit_country: 'Firmographics',
  clearbit_postal_code: 'Firmographics',
  clearbit_revenue: 'Firmographics',
  demandbase_company_name: 'Firmographics',
  demandbase_audience: 'Firmographics',
  demandbase_industry: 'Firmographics',
  demandbase_sub_industry: 'Firmographics',
  demandbase_employee_count: 'Firmographics',
  demandbase_employee_range: 'Firmographics',
  demandbase_marketing_alias: 'Firmographics',
  demandbase_annual_sales: 'Firmographics',
  demandbase_revenue_range: 'Firmographics',
  demandbase_state: 'Firmographics',
  demandbase_country_code: 'Firmographics',
  demandbase_city: 'Firmographics',
  siteVisits: 'Number of Site Visits',
  urlHost: 'URL Host',
  urlPath: 'URL Path',
  urlQuery: 'URL Query Param',
  salesforceOwner: 'Salesforce',
  targetedAccounts: 'Targeted Account',
  onlineUsers: 'Available Agents',
  leandata: 'LeanData',
}

export const CONDITION_SUB_TYPE_LABELS = {
  geoState: 'State',
  geoCountryCode: 'Country',
  clearbit_employees: 'Number of Employees',
  clearbit_raised: 'Money Raised',
  clearbit_tags_company: 'Company Category',
  clearbit_tags_market: 'Market Category',
  clearbit_tech: 'Technology Used',
  clearbit_state: 'Headquarter State',
  clearbit_country: 'Headquarter Country',
  clearbit_postal_code: 'Headquarter Postal Code',
  clearbit_revenue: 'Annual Revenue',
  demandbase_company_name: 'Company Name',
  demandbase_audience: 'In Audience',
  demandbase_industry: 'In Industry',
  demandbase_sub_industry: 'In Sub-Industry',
  demandbase_employee_count: 'Number of Employees',
  demandbase_employee_range: 'Employee Range',
  demandbase_marketing_alias: 'Marketing Alias',
  demandbase_annual_sales: 'Annual Sales',
  demandbase_revenue_range: 'Revenue Range',
  demandbase_state: 'Headquarter State',
  demandbase_country_code: 'Headquarter Country',
  demandbase_city: 'Headquarter City',
  siteVisits: 'Number of Site Visits',
  urlHost: 'URL Host',
  urlPath: 'URL Path',
  urlQuery: 'URL Query Param',
  salesforceOwner: 'Salesforce Owner',
  targetedAccounts: 'Targeted Account',
  leandata: 'LeanData Owner',
}

export const CONDITION_TYPES = {
  geoState: 'GEO',
  geoCountryCode: 'GEO',
  clearbit_employees: 'FIRMOGRAPHIC',
  clearbit_raised: 'FIRMOGRAPHIC',
  clearbit_tags_company: 'FIRMOGRAPHIC',
  clearbit_tags_market: 'FIRMOGRAPHIC',
  clearbit_tech: 'FIRMOGRAPHIC',
  clearbit_state: 'FIRMOGRAPHIC',
  clearbit_country: 'FIRMOGRAPHIC',
  clearbit_postal_code: 'FIRMOGRAPHIC',
  clearbit_revenue: 'FIRMOGRAPHIC',
  demandbase_company_name: 'FIRMOGRAPHIC',
  demandbase_audience: 'FIRMOGRAPHIC',
  demandbase_industry: 'FIRMOGRAPHIC',
  demandbase_sub_industry: 'FIRMOGRAPHIC',
  demandbase_employee_count: 'FIRMOGRAPHIC',
  demandbase_employee_range: 'FIRMOGRAPHIC',
  demandbase_marketing_alias: 'FIRMOGRAPHIC',
  demandbase_annual_sales: 'FIRMOGRAPHIC',
  demandbase_revenue_range: 'FIRMOGRAPHIC',
  demandbase_city: 'FIRMOGRAPHIC',
  demandbase_state: 'FIRMOGRAPHIC',
  demandbase_country_code: 'FIRMOGRAPHIC',
  siteVisits: 'DISPLAY_WHEN',
  urlHost: 'URL',
  urlPath: 'URL',
  urlQuery: 'URL',
  salesforceOwner: 'Salesforce Owner',
  targetedAccounts: 'Targeted Account',
  leandata: 'LeanData Owner',
}

export const AVAILABILITY_FILTER = 'onlineUsers'
export const AVAILABILITY_FILTER_OPERATORS = { 'IS_ANY': 'isAnyOf' }

export const LEANDATA_FILTER = 'leandata'



// WEBPACK FOOTER //
// ./src/scripts/app/modules/rules/constants.js